// extracted by mini-css-extract-plugin
export default {"link":"dK-z","disabled":"eK-z"};